"use client";

import { LogOut, Menu, User } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useAdminAuth } from "@/lib/auth-context";
import { useAdminShell } from "@/components/admin-shell-context";

export function AdminHeader({ title }: { title: string }) {
  const { user, logout } = useAdminAuth();
  const shell = useAdminShell();

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-border bg-background px-6">
      <div className="flex items-center gap-2">
        {shell && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="md:hidden"
            aria-label="Open navigation menu"
            onClick={() => shell.setMobileSidebarOpen(true)}
          >
            <Menu className="size-5" />
          </Button>
        )}
        <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
      </div>
      <div className="flex items-center gap-3">
        {user && (
          <span className="hidden items-center gap-1.5 text-sm text-muted-foreground sm:inline-flex">
            <User className="size-4" />
            {user.email}
          </span>
        )}
        <Button variant="outline" size="sm" onClick={() => logout()}>
          <LogOut className="size-4" />
          Sign out
        </Button>
      </div>
    </header>
  );
}
